<template>
  <v-layout class="mb-3">
    <v-flex shrink>
      <v-card width="250px" class="elevation-5">
        <v-list class="py-0" style="background-color:#000;">
          <v-list-tile>
            <v-list-tile-title style="text-align:center;font-size:20px;color:white;">ORDER WESERVE</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list dark class="py-0" style="background-color:#424242;">
          <v-list-tile v-for="item in menuItems" :key="item.status" :to="item.link">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">{{ item.status }}</v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                fab
                color="primary"
                style="height:28px;width:28px;"
                class="black--text"
              >{{ Object.keys(order_count).length === 0 && order_count.constructor === Object ? null : order_count.me_order_status['order_status_'+item.check]+ order_count.we_order_status['order_status_'+item.check] + order_count.fr_order_status['order_status_'+item.check]}}</v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <!-- <v-list dark class="py-0" style="background-color:#424242;">
          <v-list-tile>
          <v-list-tile-action>
          <v-icon>access_alarm</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="white--text">Pre order</v-list-tile-content>
          <v-list-tile-action>
            <v-btn fab color="primary" style="height:28px;width:28px;" class="black--text">{{ order_count.me_order_status['order_status_'+item.check]+ order_count.we_order_status['order_status_'+item.check]}}</v-btn>
          </v-list-tile-action>
          </v-list-tile>
        </v-list>-->
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      order_status: 1,
      interval_order: null,
      interval_list: 0,
      menuItems: [
        {
          icon: "new_releases",
          status: "Today order",
          check: "order_made",
          order_status: 1,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/ordermade",
          action: "1"
        },
        {
          icon: "list_alt",
          status: "In queue",
          check: "in_queue",
          order_status: 2,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/inqueue",
          action: "1"
        },
        {
          icon: "room_service",
          status: "Cooking",
          check: "cooking",
          order_status: 3,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/cooking",
          action: "1"
        },
        {
          icon: "pan_tool",
          status: "Ready to pick",
          check: "ready_to_pick",
          order_status: 4,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/readytopick",
          action: "1"
        },
        {
          icon: "motorcycle",
          status: "On the way",
          check: "on_the_way",
          order_status: 5,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/ontheway",
          action: "100"
        },
        {
          icon: "check_circle",
          status: "Complete",
          check: "complete",
          order_status: 6,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/completed",
          action: "55"
        },
        {
          icon: "cancel",
          status: "Cancel",
          check: "cancel",
          order_status: 7,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/cancel",
          action: "32"
        },
        {
          icon: "access_alarm",
          status: "Future order",
          check: "preorder",
          order_status: 0,
          link:
            "/weserve_admin_login/orderweserve/" +
            this.$store.state.backOffice.province +
            "/orderlist/preorder",
          action: "32"
        }
      ]
    };
  },
  watch: {
    async order_status_id() {
      // this.$store.commit('backOffice/changeLoadingProgress',true);
      this.$store.commit("fetchOrderListBack/getOrderList", {
        order_status_id: this.order_status_id,
        res_data: []
      });
      this.$emit("setFetchingOrder", true);
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.$emit("setFetchingOrder", false);
      this.$store.commit("backOffice/changeLoadingProgress", false);
    }
  },
  methods: {
    async getDataList() {
      this.$store.commit("fetchOrderListBack/getOrderList", {
        order_status_id: this.order_status_id,
        res_data: []
      });
      this.$emit("setFetchingOrder", true);
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.$emit("setFetchingOrder", false);
    },
    async getNewDataList() {
      this.$emit("setFetchingOrder", true);
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.$emit("setFetchingOrder", false);
    },
    async getCountOrder() {
      let check_res = await this.$store.dispatch(
        "fetchOrderListBack/getCountOrder"
      );
      if (JSON.stringify(check_res) != JSON.stringify(this.order_count_old)) {
        this.getNewDataList();
        this.$store.commit("fetchOrderListBack/getOldCountOrder", check_res);
      }
    }
  },
  computed: {
    ...mapState({
      order_count: state => state.fetchOrderListBack.order_count,
      selectedMenu: state => state.backOffice.selectedMenu,
      order_status_id: state => state.fetchOrderListBack.order_status_id,
      order_count_old: state => state.fetchOrderListBack.order_count_old
    })
  },
  destroyed() {
    clearInterval(this.interval_order);
    clearInterval(this.interval_list);
  },
  created() {
    this.getDataList();
    this.$store.commit("fetchOrderListBack/getCountOrder", {});
    this.$store.dispatch("fetchOrderListBack/getCountOrder");
    let vm = this;
    this.interval_order = setInterval(function() {
      vm.getCountOrder();
    }, 60000);
  }
};
</script>

